import { initializeApp, analytics } from 'firebase'

let config = {
  apiKey: 'AIzaSyCPiSe6x0Ywtv7JzZCcjVaaDeFupOjTt3o',
  authDomain: 'bacbon-school.firebaseapp.com',
  databaseURL: 'https://bacbon-school.firebaseio.com',
  projectId: 'bacbon-school',
  storageBucket: 'bacbon-school.appspot.com',
  messagingSenderId: '843876597604',
  appId: '1:843876597604:web:932bd521db1ccd9fba8471',
  measurementId: 'G-RHW3Z4Q9DL'
}

const app = initializeApp(config)
analytics()
export const db = app.database()
export const deviceRef = db.ref('registered_devices')
export const userSessionRef = db.ref('users_session')
export const streamingVideosRef = db.ref('streaming_videos')
export const activeUserRef = db.ref('active_users_log')
export const videoLogRef = db.ref('streaming_videos_log')
export const examLogRef = db.ref('exams_log')
export const activeExamRef = db.ref('active_exams')
export const activeUsersRef = db.ref('active_users')
